import { useEffect } from "react"
import { useCookies } from "react-cookie"

const Referral = (props) => {

    const [
        cookies,
        setCookie,
        // removeCookie
    ] = useCookies(['A8REFER']);

    useEffect(() => {
        
        let originalParams = props.params;

        if(originalParams.has('campaign')) {
            originalParams.delete('campaign')
        } 

        if(originalParams.has('source')) {
            originalParams.delete('source')
        } 


        let referralString = originalParams.toString(); 

        if(referralString.length > 0) {
            if(process.env.REACT_APP_REFERRAL_SOURCE_ALIAS) {
                referralString += '&source=' + process.env.REACT_APP_REFERRAL_SOURCE_ALIAS; 
            }
            
            const referralStringBase64 = btoa(referralString);
           
            const cookieMaxAge = process.env
            .REACT_APP_REFERRAL_COOKIE_EXPIRATION
            ? process.env.REACT_APP_REFERRAL_COOKIE_EXPIRATION *
                (60 * 60 * 24)
            : (60 * 60 * 24); // (60 seconds * 60 minutes * 24 hours)

            setCookie('A8REFER', referralStringBase64, {
                maxAge: cookieMaxAge,
                path: '/',
                sameSite: true,
            });
        }

        window.open(process.env.REACT_APP_REFERRAL_TRAFFIC_TRIGGER_SHORTLINK, '_self');
    },[])

    return null;
}

export default Referral